module.exports = __webpack_public_path__ + "static/media/0292_Medium.5e3040e5.jpg";